angular.module('routes.error.ErrorController', [
  'stack'
])

/**
 * The ErrorController manages view logic rendered  for errors
 *
 * @class ErrorController
 * @constructor
 * @module routes.error.ErrorController
 */
.controller('ErrorController', [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  'LoginService',
  function ($rootScope, $scope, $state, $stateParams, LoginService) {
    'use strict';

    // Copy $stateParams and add rootScope information
    var metadataDetails = $stateParams;
    var summaryConfiguration = {
      guid: 'Error ID',
      timestamp: 'Current Date and Time',
      'rootScope.user.id': 'User ID',
      'rootScope.simulation.id': 'Simulation ID',
      'rootScope.report.id': 'Report ID',
      'browser.userAgent': 'Web Browser'
    };

    metadataDetails.browser = {};
    metadataDetails.rootScope = $rootScope;
    metadataDetails.timestamp = moment().format();
    metadataDetails.guid = uuid.v1();

    // NOTE: this copies navigator.prototype properties to
    // metadata.browser as own properties so it can be serialized.
    for (var property in navigator) { // eslint-disable-line
      metadataDetails.browser[property] = navigator[property];
    }

    // Remove empty keys from Object
    Object.keys(metadataDetails).forEach(function (key) {
      if (metadataDetails[key] === null) {
        delete metadataDetails[key];
      }
    });

    // Remove internal angular properties and serialize to string
    $scope.details = JSON.stringify(metadataDetails, replacer, 4);
    $scope.summary = generateSummary(metadataDetails, summaryConfiguration);

    /**
     * Removes angular internal values from an object
     *
     * @param {string} key - key for the property
     * @param {any} value - value attached to key
     * @return {any} value to preserve, undefined to remove
     */
    function replacer(key, value) {
      if (_.includes(key, '$')) {
        return undefined;
      }
      return value;
    }

    /**
     * Generate a summary from a details object.
     * Example:
     *   var details = {a: {b: {c: 'some value'}}};
     *   var configuration = {'a.b.c': 'example title'};
     *   var result = generateSummary(details, configuration);
     *   console.log(result); //=> [{title: 'example title', value: 'some value'}]
     *
     * @param {Object|Array<Object>} details - Object like structure with detailed information
     * @param {Object} configuration - key value pairing with key being an object path
     *   and value being the title
     * @return {Array<Object>} with {title: 'string', value: 'string'}
     */
    function generateSummary(details, configuration) {
      return Object
        // find the paths to search
        .keys(configuration)
        // only retrieve values that exist
        .filter(function (key) {
          return _.has(details, key);
        })
        // generate output
        .map(function (key) {
          return {
            title: configuration[key],
            value: _.get(details, key)
          };
        });
    }

    function initialize() {
      $scope.isAuthoring = LoginService.isAuthoring;
      if ($state.current.name === 'routes.logout') {
        LoginService.clearUser();
      }
    }

    initialize();
  }
]);
